import { render, staticRenderFns } from "./SalesButton.vue?vue&type=template&id=6049bdf0&scoped=true"
import script from "./SalesButton.vue?vue&type=script&lang=js"
export * from "./SalesButton.vue?vue&type=script&lang=js"
import style0 from "./SalesButton.vue?vue&type=style&index=0&id=6049bdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049bdf0",
  null
  
)

export default component.exports